import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SBoxTable from './sbox';
import { motion } from "framer-motion";
import pg3 from "../assets/pg3.mp3"


const Page3 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  let { round } = rond;
  round = round - 1;
  let roundc = round/4 ;

  const sBoxData = [
    ['63', '7C', '77', '7B', 'F2', '6B', '6F', 'C5', '30', '01', '67', '2B', 'FE', 'D7', 'AB', '76'],
    ['CA', '82', 'C9', '7D', 'FA', '59', '47', 'F0', 'AD', 'D4', 'A2', 'AF', '9C', 'A4', '72', 'C0'],
    ['B7', 'FD', '93', '26', '36', '3F', 'F7', 'CC', '34', 'A5', 'E5', 'F1', '71', 'D8', '31', '15'],
    ['04', 'C7', '23', 'C3', '18', '96', '05', '9A', '07', '12', '80', 'E2', 'EB', '27', 'B2', '75'],
    ['09', '83', '2C', '1A', '1B', '6E', '5A', 'A0', '52', '3B', 'D6', 'B3', '29', 'E3', '2F', '84'],
    ['53', 'D1', '00', 'ED', '20', 'FC', 'B1', '5B', '6A', 'CB', 'BE', '39', '4A', '4C', '58', 'CF'],
    ['D0', 'EF', 'AA', 'FB', '43', '4D', '33', '85', '45', 'F9', '02', '7F', '50', '3C', '9F', 'A8'],
    ['51', 'A3', '40', '8F', '92', '9D', '38', 'F5', 'BC', 'B6', 'DA', '21', '10', 'FF', 'F3', 'D2'],
    ['CD', '0C', '13', 'EC', '5F', '97', '44', '17', 'C4', 'A7', '7E', '3D', '64', '5D', '19', '73'],
    ['60', '81', '4F', 'DC', '22', '2A', '90', '88', '46', 'EE', 'B8', '14', 'DE', '5E', '0B', 'DB'],
    ['E0', '32', '3A', '0A', '49', '06', '24', '5C', 'C2', 'D3', 'AC', '62', '91', '95', 'E4', '79'],
    ['E7', 'C8', '37', '6D', '8D', 'D5', '4E', 'A9', '6C', '56', 'F4', 'EA', '65', '7A', 'AE', '08'],
    ['BA', '78', '25', '2E', '1C', 'A6', 'B4', 'C6', 'E8', 'DD', '74', '1F', '4B', 'BD', '8B', '8A'],
    ['70', '3E', 'B5', '66', '48', '03', 'F6', '0E', '61', '35', '57', 'B9', '86', 'C1', '1D', '9E'],
    ['E1', 'F8', '98', '11', '69', 'D9', '8E', '94', '9B', '1E', '87', 'E9', 'CE', '55', '28', 'DF'],
    ['8C', 'A1', '89', '0D', 'BF', 'E6', '42', '68', '41', '99', '2D', '0F', 'B0', '54', 'BB', '16'],
  ];

  const toggleMute = () => {
    const audio = document.getElementById('audio');
    audio.muted = !audio.muted;
  };

  return (
    <>
      <div class="fixed top-16 right-8 h-4/5 w-1/6 rounded-xl bg-emerald-100 shadow p-4">
        <div class="text-center">
          <h2 className="text-xl pb-10 pt-4 font-semibold">Using S-Box</h2>
          <p class="text-sm">
            The next step after circular left shift is to find the subWord from it.
            <br />
            <br />
            This is done by substituting each byte of the rotated word against the Sbox shown here{" "}
            <br />
            <br />
            Now we have the Subword which will be passed onto the final step in the next page to calculate g(w{round+3})
          </p>

          <audio id="audio" controls className="mt-4 w-full">
            <source src={pg3} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <button
            onClick={toggleMute}
            className="mt-2 bg-gray-300 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded"
          >
            Mute
          </button>
        </div>
      </div>
      <div className="input-container2">
        <div className="flex flex-col items-center">
          <div>
            <p className="text-xl font-semibold">Round {roundc+1}</p>
          </div>

          <div className="flex flex-col text-xl pt-10">
            <motion.div
             initial={{ opacity: 0, scale: 0 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ delay: 1.5 }}>
            <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
              <h1 className="text-2xl font-semibold pb-3">
                What is the function g?
              </h1>
              Step 1: Rotate w{round+3} (circular left shit)
              <br></br>
              Before Rotation: {allResults[3][round+3][0]} {allResults[3][round+3][1]} {allResults[3][round+3][2]} {allResults[3][round+3][3]} 
              <br></br>
              After Rotation (X): {allResults[0][roundc][0]} {allResults[0][roundc][1]} {allResults[0][roundc][2]}{" "}
              {allResults[0][roundc][3]}{" "}
            </div></motion.div>
          </div>
          <div className="grid grid-cols-2 gap-8 content-center">
          <motion.div
             initial={{ opacity: 0, scale: 0 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ delay: 2.5 }}>
            <div className="text-xl pt-20">
              <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                Step 2: Using S-box of AES SubWord is found
                <br></br>
                After Rotation (X): {allResults[0][roundc][0]} {allResults[0][roundc][1]} {allResults[0][roundc][2]}{" "}
              {allResults[0][roundc][3]}{" "}<br />
                SubWord (Y): {allResults[1][roundc][0]} {allResults[1][roundc][1]} {allResults[1][roundc][2]}{" "}
              {allResults[1][roundc][3]}{" "}
              </div>
              
            </div></motion.div>

            <div className="row-span-2">
            <motion.div
             initial={{ opacity: 0, scale: 0 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ delay: 3.5 }}>
            <SBoxTable sBoxData={sBoxData} highlightedRow={allResults[0][roundc][0][0]} highlightedColumn={allResults[0][roundc][0][1]} />
            </motion.div></div>

            <div>
            <motion.div
             initial={{ opacity: 0, scale: 0 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ delay: 3.5 }}>
            <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                The byte is taken and checked against S-Box table against row and column
                <br />
                Eg: Here {allResults[0][roundc][0]} is checked against row <b>{allResults[0][roundc][0][0]}</b> and column <b>{allResults[0][roundc][0][1]}</b>
                <br />
                Here the value is <b>{allResults[1][roundc][0]}</b>
              </div>
              </motion.div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Page3;
